import React from 'react';
import './SessionTimeoutWarning.css';

interface SessionTimeoutWarningProps {
  isOpen: boolean;
  secondsRemaining: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export const SessionTimeoutWarning: React.FC<SessionTimeoutWarningProps> = ({
  isOpen,
  secondsRemaining,
  onStayLoggedIn,
  onLogout
}) => {
  if (!isOpen) return null;

  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds} seconds`;

  return (
    <div className="session-timeout-overlay">
      <div className="session-timeout-dialog">
        <div className="session-timeout-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12,6 12,12 16,14" />
          </svg>
        </div>

        <div className="session-timeout-header">
          <h3>Session Expiring</h3>
        </div>

        <div className="session-timeout-body">
          <p>Your session will expire due to inactivity.</p>
          <p className="session-timeout-countdown">
            Time remaining: <span className="countdown-timer">{timeDisplay}</span>
          </p>
          <p className="session-timeout-hint">
            Click "Stay Logged In" to continue your session.
          </p>
        </div>

        <div className="session-timeout-actions">
          <button
            onClick={onStayLoggedIn}
            className="stay-logged-in-button"
            autoFocus
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            className="logout-now-button"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};
